import React from 'react'

const Ncc = () => {
  return (
    <div>Ncc</div>
  )
}

export default Ncc